import { ApiClient } from "./clients";

export class BotClickManager {
  constructor(private readonly apiClient: ApiClient) {}

  async track(tgBot: string, tgBotButtonClick: string): Promise<void> {
    await this.apiClient.post("/bot-click", { tgBot, tgBotButtonClick });
  }
}
